import React from "react";

export const Features = () => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>О нас</h2>
          <p className="about-use">В нашем Центре Психологии мы верим, что каждый человек способен раскрыть свои лучшие качества, найти свое истинное «Я» и создать гармоничные отношения с окружающим миром.<br/> Наша команда профессионалов предлагает широкий спектр психологических услуг, включая персональное, семейное и детское консультирование, а также бизнес-психологию и психологию творчества.</p>
        </div>
      </div>
    </div>
  );
};
